/* Lampiero v9: night mode, the 1-in-3 sticker on the bundle rows, Add to cart straight to checkout,
   question cards, entrance animations with variance, count-up numbers. No libraries. Every block guards itself. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var LVT = w.LV_T || {};
  function root() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
  html.classList.add('lv9-js');
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = w.matchMedia && w.matchMedia('(max-width: 749px)').matches;
  function each(sel, fn, root) { [].forEach.call((root || d).querySelectorAll(sel), function (el, i) { try { fn(el, i); } catch (e) { if (w.console) console.warn('lv9', sel, e); } }); }
  function safe(fn) { try { fn(); } catch (e) { if (w.console) console.warn('lv9', e); } }

  /* 1. night mode: one attribute on <html>. R4: on by itself between 20:00 and 06:00 visitor time (set in the <head>,
        so there is no flash); once the visitor uses the toggle, their choice wins and is remembered. */
  safe(function () {
    var KEY = 'lv9-night';
    function isOn() { return html.hasAttribute('data-lv-night'); }
    function chosen() { try { var v = localStorage.getItem(KEY); return v === '1' || v === '0' ? v : null; } catch (e) { return null; } }
    function evening() { var h = new Date().getHours(); return h >= 20 || h < 6; }
    function paint() { each('[data-lv9-night]', function (b) { b.setAttribute('aria-pressed', isOn() ? 'true' : 'false'); }); }
    function apply(on) {
      if (on === isOn()) return;
      if (!reduce) { html.classList.add('lv9-nm-anim'); clearTimeout(apply.t); apply.t = setTimeout(function () { html.classList.remove('lv9-nm-anim'); }, 650); }
      if (on) html.setAttribute('data-lv-night', ''); else html.removeAttribute('data-lv-night');
      paint();
    }
    function set(on) { apply(on); try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {} paint(); }
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lv9-night]');
      if (!b) return;
      e.preventDefault(); set(!isOn());
    });
    /* a page left open across 20:00 or 06:00 follows the clock too, as long as the visitor has not chosen */
    function follow() { if (!chosen()) apply(evening()); }
    setInterval(follow, 60000);
    d.addEventListener('visibilitychange', function () { if (!d.hidden) follow(); });
    w.lvNight = set;
    paint();
  });

  /* 2. the 1-in-3 sticker sits on the bundle rows (outside Kaching's own markup, so an app update never removes it) */
  function stickers() {
    each('[data-lv9-stick]', function (st) {
      var box = st.closest('.product__info-container, product-info, .product, section') || d;
      var kb = box.querySelector('kaching-bundles-block') || d.querySelector('kaching-bundles-block');
      if (kb && kb.parentNode && st.nextElementSibling !== kb) { kb.parentNode.insertBefore(st, kb); st.classList.add('is-on-k'); }
    });
  }
  safe(stickers);
  setTimeout(function () { safe(stickers); }, 1500);

  /* 3. Add to cart goes straight to checkout. Kaching's own skip-cart usually does this; this is the safety net:
        after any successful add to cart, once the cart calls are quiet, go to checkout unless the page is already leaving. */
  safe(function () {
    if (!w.lvCheckout) return;
    var leaving = false, lastCart = 0, addAt = 0, timer = 0;
    w.addEventListener('beforeunload', function () { leaving = true; });
    w.addEventListener('pagehide', function () { leaving = true; });
    function isCart(u) { return /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(u || ''); }
    function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); }
    function check() {
      timer = 0;
      if (leaving || !addAt) return;
      if (Date.now() - lastCart < 900) { timer = setTimeout(check, 300); return; }
      fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (!leaving && c && c.item_count > 0) { leaving = true; w.location.href = root() + 'checkout'; }
      }).catch(function () { if (!leaving) w.location.href = root() + 'checkout'; });
    }
    function added() { addAt = Date.now(); lastCart = Date.now(); if (!timer) timer = setTimeout(check, 1600); }
    var of = w.fetch;
    if (of) w.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (isCart(u)) {
        lastCart = Date.now();
        p.then(function (r) { lastCart = Date.now(); if (isAdd(u) && r && r.ok) added(); }, function () {});
      }
      return p;
    };
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (isCart(u)) { this.addEventListener('loadend', function () { lastCart = Date.now(); if (isAdd(u) && this.status >= 200 && this.status < 300) added(); }); }
      return xo.apply(this, arguments);
    };
    if ('PerformanceObserver' in w) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) { if (isCart(en.name)) { lastCart = Date.now(); if (isAdd(en.name)) added(); } });
        }).observe({ type: 'resource', buffered: false });
      } catch (e) {}
    }
    /* a click on any buy button shows it is working */
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-form__submit, [data-lv6-add], [data-lv-sticky-add]');
      if (b) { b.classList.add('lv9-busy'); setTimeout(function () { b.classList.remove('lv9-busy'); }, 6000); }
    }, true);
  });

  /* 3b. Kaching: tapping the row that is already chosen used to un-choose it and fall back to 1 lamp
         (tap "2 lamps" twice, get 1 lamp in checkout). A tap on the chosen row now keeps it chosen. */
  safe(function () {
    function guard(e) {
      var bar = e.target.closest && e.target.closest('.kaching-bundles__bar');
      if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) return;
      if (e.target.closest('select, input:not([type="radio"]), textarea, [class*="quantity"], [class*="variant"]')) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.stopPropagation(); e.preventDefault();
    }
    d.addEventListener('click', guard, true);
    d.addEventListener('keydown', guard, true);
  });

  /* 4. links to the sets on a page without sets go to the buy box, or to the product page */
  safe(function () {
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#lv-sets"]');
      if (!a || d.getElementById('lv-sets')) return;
      e.preventDefault();
      if (d.getElementById('lv-offer') && w.lvGo) w.lvGo('lv-offer');
      else w.location.href = root() + 'products/lampiero-670nm-red-night-light-portable-bedside-sleep-lamp#lv-offer';
    }, true);
  });

  /* R4-7. the hero button that points at the offer first goes to the explanation: the section right after the hero.
           Every other button on the page keeps going to the offer. */
  safe(function () {
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-lv9-next]');
      if (!a) return;
      var sec = a.closest('.shopify-section'), nx = sec && sec.nextElementSibling;
      while (nx && (nx.offsetHeight < 2 || getComputedStyle(nx).display === 'none')) nx = nx.nextElementSibling;
      if (!nx) return;
      e.preventDefault(); e.stopPropagation();
      var y = nx.getBoundingClientRect().top + w.pageYOffset;
      w.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduce ? 'auto' : 'smooth' });
    }, true);
  });

  /* 5. question cards: on a phone, the ones further down start closed with a clear "+", so the page reads quicker */
  safe(function () {
    if (!phone) return;
    var vh = w.innerHeight;
    each('details[data-lv9-co="q"]', function (el) { if (el.getBoundingClientRect().top > vh) el.open = false; });
  });


  /* ===== v9 round 2 ===== */
  /* v10: the language is the shop language (Shopify languages: <html lang> is en, de, pt-PT ...), the words come from
     window.LV_T (snippets/lv-t, theme locale files). Weglot is gone. */
  function lang() { return ((html.lang || '').trim() || 'en').slice(0, 2).toLowerCase(); }

  /* R2-13. "1 lamp", "2 lamps": v10 from the theme locale files (LV_T.lamps, 1 to 12, with the language's own plural forms);
     the list below only until a language has its lv.lamps key */
  var LAMPS = {
    en: ['1 lamp', '2 lamps', '3 lamps', '4 lamps'], nl: ['1 lamp', '2 lampen', '3 lampen', '4 lampen'], de: ['1 Lampe', '2 Lampen', '3 Lampen', '4 Lampen'],
    fr: ['1 lampe', '2 lampes', '3 lampes', '4 lampes'], it: ['1 lampada', '2 lampade', '3 lampade', '4 lampade'], es: ['1 lámpara', '2 lámparas', '3 lámparas', '4 lámparas'],
    pl: ['1 lampa', '2 lampy', '3 lampy', '4 lampy'], pt: ['1 candeeiro', '2 candeeiros', '3 candeeiros', '4 candeeiros'], cs: ['1 lampa', '2 lampy', '3 lampy', '4 lampy'],
    el: ['1 λάμπα', '2 λάμπες', '3 λάμπες', '4 λάμπες'], ar: ['مصباح واحد', 'مصباحان', '3 مصابيح', '4 مصابيح']
  };
  w.lv9Lamps = function (q) {
    var lg = lang(), l = LAMPS[lg] || LAMPS.en; q = Math.max(1, q || 1);
    var lt = LVT.lamps && LVT.lamps[q];
    if (typeof lt === 'string' && lt && (lg === 'en' || lt !== (q === 1 ? '1 lamp' : q + ' lamps'))) return lt;
    if (q <= 4) return l[q - 1];
    /* v9.7: 5 lamps and up (the 4-lamp row's stepper). Polish and Czech use the genitive plural from 5 */
    if (lg === 'pl') return q + (q % 10 >= 2 && q % 10 <= 4 && (q % 100 < 12 || q % 100 > 14) ? ' lampy' : ' lamp');
    if (lg === 'cs') return q + ' lamp';
    return l[3].replace(/^4/, String(q));
  };
  function relabel() {
    each('[data-lv9-lamps]', function (el) { var t = w.lv9Lamps(parseInt(el.getAttribute('data-lv9-lamps'), 10)); if (el.textContent !== t) el.textContent = t; });
    if (w.lv8Tidy) w.lv8Tidy();
    var bars = [].slice.call(d.querySelectorAll('.kaching-bundles__bar')), st = d.querySelector('[data-lv-sticky-title]');
    for (var i = 0; i < bars.length; i++) if (bars[i].classList.contains('kaching-bundles__bar--selected') && st) st.textContent = w.lv9Lamps(w.lv8Qty ? w.lv8Qty(bars[i], i) : i + 1);
    /* R5: the sets button label comes from translated words in the page; the hero refits to the new text length */
    each('[data-lv6-sets]', function (r) { if (r.__lv6paint) r.__lv6paint(); });
    if (w.lv9HeroFit) w.lv9HeroFit();
  }
  /* R3. small labels: hyphenate where the browser can; a long compound that still does not fit makes the type a little smaller (never a split without a hyphen) */
  var FIT = '.lv9-sw__l,.lv9-sw__s,.lv-ba__tag,.lv-ba-cap__t,.lv-ba-cap p,.lv9-rail__cap,.lv6-rail__card figcaption,.lv6-pick__n,.lv6-pick__room,.lv6-set__n,.lv6-set__room,.lv6-set__deal,' +
    '.lv8-night__t,.lv8-night__s,.lv8-step__t,.lv-feat .lv-h4,.lv6-vs__c span,.lv-cmp th,.lv9-co__t,.lv-persona b,.lv6-link__body b,.lv9-dx__l a,.lv-sw__cap-t,.lv6-bar__l b,.kaching-bundles__bar-title,.lv8-kline,.lv-gal__cap-t,.lv6-anat__t,.lv6-anat__d,.lv8-night__tag';
  /* last resort for a compound longer than its box: soft hyphens at the joints of the compound, so the browser breaks it with a visible hyphen */
  var HEADS = /(insteek|zimmer|tisch|nacht|schlaf|nahrungs|ergänzungs|sonnen|untergangs|toiletten|kinder|regenbogen|bade|lese|steck|dosen|salz|pilz|wand|decken|zonsonder|onder|slaap|bedlamp|voeding|kinder|lampe|lamp|licht|gang|mittel)/gi;
  function shy(el) {
    var walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), t, changed = false;
    while ((t = walker.nextNode())) {
      var v = t.nodeValue;
      if (v.indexOf('\u00AD') > -1) continue;
      var nv = v.replace(/[A-Za-zÀ-ÿ]{10,}/g, function (wd) {
        /* joints = where a known word part starts (Telefoon|licht, Nacht|tisch|lampe); ends only where no start is near; never every-n-letters */
        var pts = [], ends = [], m; HEADS.lastIndex = 0;
        while ((m = HEADS.exec(wd))) { var st = m.index, e = m.index + m[0].length; if (st >= 4 && st <= wd.length - 4) pts.push(st); if (e >= 4 && e <= wd.length - 4) ends.push(e); }
        ends.forEach(function (e) { if (!pts.some(function (q) { return Math.abs(q - e) < 4; })) pts.push(e); });
        pts.sort(function (x, y) { return x - y; });
        pts = pts.filter(function (q, i) { return i === 0 || q - pts[i - 1] >= 3; });
        if (!pts.length) return wd;
        var out = '', last = 0; pts.forEach(function (q) { out += wd.slice(last, q) + '\u00AD'; last = q; }); return out + wd.slice(last);
      });
      if (nv !== v) { t.nodeValue = nv; changed = true; }
    }
    return changed;
  }
  function over(el) { return el.scrollWidth > el.clientWidth + 1; }
  function fitWords() {
    each(FIT, function (el) {
      if (!el.offsetWidth || !el.textContent.trim()) return;
      var cl = el.closest('details'); if (cl && !cl.open && !el.closest('summary')) return;
      if (el.getAttribute('data-lv9-fs')) el.style.removeProperty('font-size');
      var fs0 = parseFloat(getComputedStyle(el).fontSize), fs = fs0, n = 0;
      function down(min) { while (over(el) && fs > min && n++ < 30) { fs -= 0.5; el.style.setProperty('font-size', fs + 'px', 'important'); el.setAttribute('data-lv9-fs', '1'); } }
      down(Math.max(11, fs0 * 0.82));
      if (over(el) && shy(el)) { el.style.removeProperty('font-size'); fs = fs0; n = 0; down(Math.max(11, fs0 * 0.82)); }
      down(Math.max(10.5, fs0 * 0.68));
    });
  }
  w.lv9FitWords = fitWords;
  d.addEventListener('toggle', function (e) { if (e.target && e.target.open) setTimeout(function () { safe(fitWords); }, 60); }, true);
  safe(fitWords); w.addEventListener('load', function () { safe(fitWords); }); setTimeout(function () { safe(fitWords); }, 2500); setTimeout(function () { safe(fitWords); }, 6000);
  safe(relabel);

  /* R2-6. language switcher in the header (desktop) and in the menu (phones).
     v10: Shopify languages. The list is the shop's published languages (LV_T.langs, names in their own language);
     a tap posts the theme's hidden localization form (snippets/lv-t), Shopify answers with the same page in that language.
     With one published language the switcher stays hidden. */
  safe(function () {
    var langs = (LVT.langs || []).filter(function (l) { return l && l.code; });
    var form = d.getElementById('lv9-lang-form');
    /* v10: in theme preview the languages are not published yet, so Shopify lists only English.
       Preview only (theme role not main): show the fixed list and switch by link (/de/..., pt-PT lives at /pt/). */
    var linkMode = false;
    var role = (w.Shopify && w.Shopify.theme && w.Shopify.theme.role) || 'main';
    if ((langs.length < 2 || !form) && role !== 'main') {
      langs = [['en','English'],['de','Deutsch'],['fr','Français'],['nl','Nederlands'],['es','Español'],['it','Italiano'],['pl','Polski'],['pt-PT','Português'],['cs','Čeština'],['el','Ελληνικά']]
        .map(function (a) { return { code: a[0], name: a[1] }; });
      linkMode = true;
    }
    if (langs.length < 2 || (!form && !linkMode)) return;
    var cur = (LVT.lang || html.lang || 'en').toLowerCase();
    function langUrl(code) {
      var rest = w.location.pathname.replace(/^\/(de|fr|nl|es|it|pl|pt|pt-pt|cs|el|sv|nb|da|fi|hu|sl|ro|sk|hr|bg|lt|lv|et)(?=\/|$)/i, '') || '/';
      var pre = code === 'en' ? '' : '/' + (code === 'pt-PT' ? 'pt' : code);
      return (pre + (rest === '/' && pre ? '' : rest)) + w.location.search.replace(/[?&]preview_theme_id=\d+/, '').replace(/^&/, '?') + w.location.hash;
    }
    each('[data-lv9-lang-cur]', function (b) { b.textContent = cur.slice(0, 2).toUpperCase(); });
    each('[data-lv9-lang-list]', function (box) {
      box.innerHTML = '';
      langs.forEach(function (l) {
        var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-l', l.code);
        b.setAttribute('aria-current', l.code.toLowerCase() === cur ? 'true' : 'false');
        /* lv11: Shopify gives some names in lower case ("français", "português (Portugal)", "čeština"): capital first letter only */
        var s1 = d.createElement('span'); s1.textContent = l.name ? l.name.charAt(0).toUpperCase() + l.name.slice(1) : l.code.toUpperCase();
        var s2 = d.createElement('small'); s2.textContent = l.code.slice(0, 2).toUpperCase();
        b.appendChild(s1); b.appendChild(s2); box.appendChild(b);
      });
    });
    each('[data-lv9-lang]', function (el) { el.hidden = false; });
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lv9-lang-list] button');
      if (b) {
        e.preventDefault();
        var inp = form && form.querySelector('input[name="locale_code"]');
        if (b.getAttribute('data-l').toLowerCase() !== cur) {
          if (linkMode) w.location.href = langUrl(b.getAttribute('data-l'));
          else if (inp) { inp.value = b.getAttribute('data-l'); form.submit(); }
        }
        each('details[data-lv9-lang]', function (dd) { dd.open = false; });
        return;
      }
      if (!(e.target.closest && e.target.closest('details[data-lv9-lang]'))) each('details[data-lv9-lang]', function (dd) { dd.open = false; });
    });
  });

  /* R2-7. buttons stay on one line on phones: the type steps down a little when a label is long */
  function fitButtons() {
    if (!w.matchMedia('(max-width: 749px)').matches) return;
    each('.lv-btn', function (b) {
      if (!b.offsetWidth) return;
      b.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(b).fontSize), n = 0;
      while (b.scrollWidth > b.clientWidth + 1 && fs > 14 && n++ < 12) { fs -= 0.5; b.style.setProperty('font-size', fs + 'px', 'important'); }
    });
  }
  safe(fitButtons); w.addEventListener('load', function () { safe(fitButtons); });
  var rz = 0; w.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { safe(fitButtons); safe(grids); safe(fitWords); }, 200); });

  /* R2-9. grids always look complete: the last row is centred on wide screens; on phones an odd number of cards becomes a swipe row with dots */
  var GRIDS2 = [['.lv-personas', 3], ['.lv8-nights__grid', 4], ['.lv6-rail__track', 4], ['.lv6-links__grid', 4]];
  function cols(n, base) { if (n <= 2) return 3; if (n <= 4) return n; if (n === 5 || n === 6 || n === 9) return 3; return 4; }
  function grids() {
    var wide = w.matchMedia('(min-width: 750px)').matches;
    GRIDS2.forEach(function (g) {
      each(g[0], function (grid) {
        var kids = [].filter.call(grid.children, function (c) { return c.nodeType === 1 && !c.hidden && getComputedStyle(c).display !== 'none'; });
        var n = kids.length; if (!n) return;
        grid.style.setProperty('--c', cols(n, g[1]));
        grid.classList.toggle('lv9-flex', wide);
        var snap = !wide && (n % 2 === 1 || g[0] === '.lv6-links__grid');
        grid.classList.toggle('lv9-snap', snap);
        var dots = grid.nextElementSibling && grid.nextElementSibling.classList.contains('lv9-dots') ? grid.nextElementSibling : null;
        if (snap && !dots) {
          dots = d.createElement('div'); dots.className = 'lv9-dots'; dots.setAttribute('aria-hidden', 'true');
          for (var i = 0; i < n; i++) dots.appendChild(d.createElement('i'));
          grid.parentNode.insertBefore(dots, grid.nextSibling);
          var t = 0;
          grid.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(function () {
            var c = grid.children[0], step = c ? c.getBoundingClientRect().width + 12 : 1;
            var k = Math.round(grid.scrollLeft / step); if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4) k = n - 1;
            [].forEach.call(dots.children, function (x, j) { x.className = j === k ? 'is-on' : ''; });
          }); }, { passive: true });
          dots.children[0].className = 'is-on';
        }
        if (dots) dots.hidden = !snap;
      });
    });
  }
  safe(grids);

  /* 6. entrance animations: a different motion per kind of block, only below the first screen, transform and opacity only */
  safe(function () {
    if (reduce || !('IntersectionObserver' in w)) { each('[data-lv9-stick]', function (s) { s.classList.add('is-in'); }); return; }
    var vh = w.innerHeight;
    function below(el) { return el.getBoundingClientRect().top > vh * 0.98; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var f = e.target.__lv9; e.target.__lv9 = null; if (f) f();
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    var pend = [];
    function watch(el, fn) {
      var prev = el.__lv9;
      el.__lv9 = prev ? function () { prev(); fn(); } : fn;
      if (!prev) { io.observe(el); pend.push(el); }
    }
    /* a fast fling or a jump to the offer can skip a block: anything already above the bottom of the screen is shown */
    var tk = 0;
    function sweep() {
      tk = 0; var lim = w.innerHeight * 0.96;
      pend = pend.filter(function (el) {
        if (!el.__lv9) return false;
        if (el.getBoundingClientRect().top < lim) { var f = el.__lv9; el.__lv9 = null; io.unobserve(el); f(); return false; }
        return true;
      });
      if (!pend.length) w.removeEventListener('scroll', onSc);
    }
    function onSc() { if (!tk) tk = setTimeout(sweep, 180); }
    w.addEventListener('scroll', onSc, { passive: true });
    function show(el) { el.classList.add('is-a'); setTimeout(function () { el.removeAttribute('data-a'); el.classList.remove('is-a'); el.style.removeProperty('--d'); }, 1700); }

    /* grids: the children come in one after another, 60 ms apart */
    var GRIDS = [
      ['.lv8-nights__grid', 'pic'], ['.lv6-rail__track', 'pic'], ['.lv-feats', 'pic'], ['.lv6-links__grid', 'pic'], ['.lv-personas', 'pic'],
      ['.lv6-sets__grid', 'pic'], ['.lv8-steps__grid', 'up'], ['.lv-qstrip', 'up'], ['.lv-rgrid', 'up'], ['.lv-faq', 'up'], ['.lv-auth', 'up'], ['.lv6-pick__grid', 'up'], ['.lv-ba-cap', 'up']
    ];
    GRIDS.forEach(function (g) {
      each(g[0], function (grid) {
        if (!below(grid)) return;
        var kids = [].filter.call(grid.children, function (c) { return c.nodeType === 1 && !c.hidden; });
        kids.forEach(function (c, i) { c.setAttribute('data-a', g[1]); c.style.setProperty('--d', Math.min(i, 7) * 60 + 'ms'); });
        watch(grid, function () { kids.forEach(show); });
      });
    });
    /* two-column blocks: the problem side slides in from the left, the answer from the right */
    each('.lv6-vs', function (vs) {
      if (!below(vs)) return;
      var cells = [];
      each('.lv6-vs__row', function (row, r) {
        each('.lv6-vs__c--bad', function (c) { c.setAttribute('data-a', 'left'); c.style.setProperty('--d', Math.min(r, 6) * 70 + 'ms'); cells.push(c); }, row);
        each('.lv6-vs__c--good', function (c) { c.setAttribute('data-a', 'right'); c.style.setProperty('--d', (Math.min(r, 6) * 70 + 120) + 'ms'); cells.push(c); }, row);
      });
      watch(vs, function () { cells.forEach(show); });
    });
    /* single cards: a lift; pictures: a soft zoom */
    each('.lv9-storycard, .lv9-co, .lv9-pull, .lv-inline-offer, .lv-cmp, .lv-guar, .lv-chooser__panel', function (el) {
      if (!below(el) || el.closest('[data-a]')) return; el.setAttribute('data-a', 'up'); watch(el, function () { show(el); });
    });
    each('.lv6-stat__card, .lv-big', function (el) { if (!below(el)) return; el.setAttribute('data-a', 'zoom'); watch(el, function () { show(el); }); });
    each('.lv-sw__media, .lv-ba-wrap, .lv-figure', function (el) { if (!below(el) || el.closest('[data-a]')) return; el.setAttribute('data-a', 'pic'); watch(el, function () { show(el); }); });

    /* numbers count up (the 90 minutes, percentages), the width is held so nothing moves */
    each('.lv6-stat__num, .lv-big__num, .lv-stat b', function (el) {
      var raw = el.textContent.trim(), m = raw.match(/^(\d{1,4})(%?)$/);
      if (!m || !below(el)) return;
      var to = parseInt(m[1], 10), suf = m[2];
      watch(el, function () {
        el.style.display = 'inline-block'; el.style.minWidth = el.getBoundingClientRect().width + 'px'; el.style.textAlign = 'center';
        var t0 = performance.now(), dur = 1300;
        (function f(now) {
          var t = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(to * e) + suf;
          if (t < 1) requestAnimationFrame(f); else el.textContent = raw;
        })(t0);
      });
    });
    /* the sticker gives one small wiggle and a shine when it comes into view */
    each('[data-lv9-stick], [data-lv9-stick-sets]', function (s) { watch(s, function () { s.classList.add('is-in'); }); });
    /* buttons: one soft glow when they arrive */
    each('.lv-btn', function (b) {
      if (!below(b) || b.closest('.lv-sticky, .lv-hero, .lv8-view, .menu-drawer')) return;
      watch(b, function () { b.classList.add('lv9-glow'); setTimeout(function () { b.classList.remove('lv9-glow'); }, 1800); });
    });
  });
})();
